/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";

/**
 * Calculates the changes between two objects ie. added, changed, removed.
 * @param {Object} objectA
 * @param {Object} objectB
 * @returns {Array}
 */
export default function diff(objectA, objectB) {
    var changes = [];

    _.each(objectA, function(value, key) {
        if (!objectB.hasOwnProperty(key)) {
            changes.push({
                key: key,
                type: "deleted",
                oldValue: objectA[key]
            });
        } else if (!_.isEqual(objectA[key], objectB[key])) {
            changes.push({
                key: key,
                type: "changed",
                oldValue: objectA[key],
                value: objectB[key]
            });
        }
    });

    _.each(objectB, function(value, key) {
        if (!objectA.hasOwnProperty(key)) {
            changes.push({
                key: key,
                type: "added",
                value: objectB[key]
            });
        }
    });

    return changes;
}

